import { inject, Injectable } from '@angular/core';

import { FEATURE_FLAG, FeatureFlags } from './feature-flag.model';
import { FEATURE_FLAGS } from './feature-flags.config';

const STORAGE_KEY = 'romulus-flags';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private readonly flags: FeatureFlags = { ...inject(FEATURE_FLAGS), ...storedFlags() };

  public enabled(flag: FEATURE_FLAG): boolean {
    return this.flags[flag];
  }
}

function storedFlags(): Partial<Record<FEATURE_FLAG, boolean>> {
  const flags: Partial<Record<FEATURE_FLAG, boolean>> = {};
  try {
    const stored: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '{}');
    const values: Record<string, unknown> = typeof stored === 'object' && stored !== null ? { ...stored } : {};
    for (const flag of Object.values(FEATURE_FLAG)) {
      const value = values[flag];
      if (typeof value === 'boolean') {
        flags[flag] = value;
      }
    }
  } catch {
    return {};
  }

  return flags;
}
